import { mapGetters, mapActions } from 'vuex';
import Storage from '@homeservices/tool-kit/storage/local-storage';

import { SCHEDULE_PASS_OPTION } from '@/constants/pass-options';

export default {
  PASS_COUNT_THRESHOLD: 5,
  FIRST_PASS_COUNT_THRESHOLD: 1,
  computed: {
    ...mapGetters('user', [
      'userId',
    ]),
    ...mapGetters('ui', [
      'passEducation',
    ]),
    previouslyPassedKey () {
      return `${this.userId}-passed`;
    },
    busyPassCountKey () {
      return `${this.userId}-busy-pass-count`;
    },
    shouldNotifyFirstPass () {
      return !this.passEducation.previouslyPassed;
    },
    shouldNotifyBusyPass () {
      return (
        (this.passEducation.busyPassCount >= this.$options.PASS_COUNT_THRESHOLD)
        || (this.passEducation.busyPassCount === this.$options.FIRST_PASS_COUNT_THRESHOLD
        && this.shouldNotifyFirstPass)
      );
    },
  },
  mounted () {
    const previouslyPassed = Storage.get(this.previouslyPassedKey)
      || this.passEducation.previouslyPassed;
    const busyPassCount = Storage.get(this.busyPassCountKey) || this.passEducation.busyPassCount;

    if (previouslyPassed !== this.passEducation.previouslyPassed) {
      this.patchPassEducation({
        previouslyPassed,
      });
    }

    if (busyPassCount !== this.passEducation.busyPassCount) {
      this.patchPassEducation({
        busyPassCount,
      });
    }
  },
  watch: {
    'passEducation.busyPassCount': function busyPassCount () {
      Storage.set(this.busyPassCountKey, this.passEducation.busyPassCount);
    },
    'passEducation.previouslyPassed': function previouslyPassed () {
      Storage.set(
        this.previouslyPassedKey,
        this.passEducation.previouslyPassed
      );
    },
  },
  methods: {
    ...mapActions('ui', [
      'patchPassEducation',
    ]),
    incrementCounters ({ reason }) {
      if (
        reason === SCHEDULE_PASS_OPTION.reason
        && this.passEducation.busyPassCount <= this.$options.PASS_COUNT_THRESHOLD
      ) {
        this.incrementBusyPassCount();
      } else {
        this.resetBusyPassCount();
      }
    },
    incrementBusyPassCount () {
      this.patchPassEducation({
        busyPassCount: this.passEducation.busyPassCount + 1,
      });
    },
    resetBusyPassCount () {
      this.patchPassEducation({
        busyPassCount: 0,
      });
    },
    setPreviouslyPassed () {
      this.patchPassEducation({
        previouslyPassed: true,
      });
    },
  },
};
